/** * * Asynchronously loads the component for
InternationalCalls
* */ import { lazyLoad } from "utils/loadable";
export const InternationalCalls = lazyLoad(
  () => import("./index"),
  (module) => module.InternationalCalls
);
